const normalize = (items = []) =>
  items.map((r) => ({
    cie: r.cie10 ?? r.cie ?? r.codigo ?? r.code ?? '',
    motivo: r.motivo ?? r.descripcion ?? r.desc ?? r.detalle ?? '',
    cantidad: r.cantidad ?? r.denuncias ?? r.total ?? r.cant ?? '',
  }))

const buildRankingTable = (title, rows, marginTop = '5mm') => `
  <div class="table-section" style="margin-top:${marginTop}">
    <div class="section-title">${title}</div>
    <table class="rnk">
      <tr><th style="width:70px;text-align:center;">CIE-10</th><th>Motivo</th><th style="width:100px;text-align:center;">Cantidad</th></tr>
      ${
        rows && rows.length
          ? rows
              .map(
                (r, i) =>
                  `<tr class="${i % 2 === 1 ? 'alt' : ''}"><td style="text-align:center;">${r.cie ?? ''}</td><td>${r.motivo ?? ''}</td><td style="text-align:center;">${r.cantidad ?? ''}</td></tr>`
              )
              .join('')
          : `<tr><td colspan="3" class="empty-msg" style="height:56px;">Esta contingencia no cuenta con siniestros para este período</td></tr>`
      }
    </table>
  </div>`

const findByTipo = (data, keywords) => {
  if (!Array.isArray(data)) return []
  const group = data.find((g) => {
    const desc = String(g.tipoDescripcion ?? g.tipo ?? '').toLowerCase()
    return keywords.some((kw) => desc.includes(kw))
  })
  return group?.denuncias ?? []
}

export const buildRankingSection = (topRankingSiniestros) => {
  let lt = [],
    it = [],
    ep = []

  if (topRankingSiniestros) {
    if (Array.isArray(topRankingSiniestros)) {
      lt = normalize(findByTipo(topRankingSiniestros, ['lugar de trabajo', 'lugar_trabajo', 'lt']))
      it = normalize(findByTipo(topRankingSiniestros, ['in itinere', 'in_itinere', 'itinere']))
      ep = normalize(findByTipo(topRankingSiniestros, ['enfermedad', 'ep']))
    } else {
      lt = normalize(topRankingSiniestros.lugarTrabajo || topRankingSiniestros.lugar_trabajo || [])
      it = normalize(topRankingSiniestros.inItinere || topRankingSiniestros.in_itinere || [])
      ep = normalize(topRankingSiniestros.enfermedadProfesional || topRankingSiniestros.enfermedad_profesional || [])
    }
  }

  return [
    buildRankingTable('DENUNCIAS - LUGAR DE TRABAJO', lt, '14.17px'),
    buildRankingTable('DENUNCIAS - IN ITÍNERE', it),
    buildRankingTable('DENUNCIAS - ENFERMEDAD PROFESIONAL', ep),
  ].join('')
}
